import { useState, useEffect } from "react";

export default function useDebounce(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    // This shall get called everytime there is a change in the search string
    // Everytime this method is Called, it will initiate a new timer, and clear out old timers if any.
    // Refer routes/BulkJobs/BulkJobsDetails/BulkJobModelsDataGrid.js for usage
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}
